import GameFrame from '@/ports-frontend/GameFrame';
import MessageBus from '@/ports-frontend/MessageBus';

export const initializeGameFrameBridge = async () => {
  const messages: string[] = [];
  try {
    MessageBus.onSubscribe(
      data => {
        if (!messages.includes(data.message)) {
          GameFrame.postMessageToGameFrame(data.message, data.payload);
        } else {
          messages.splice(messages.indexOf(data.message), 1);
        }
      },
      ['*']
    );

    GameFrame.onMessage(
      ({ message }: { message?: { topic: string; data: any } }) => {
        message &&
          message.topic &&
          messages.push(message.topic) &&
          MessageBus.publishEvent(message);
      }
    );
  } catch (err) {
    console.log(err);
    throw err;
  }
};
